export default __webpack_public_path__ + "static/media/joshua.86db88b3.jpeg";